// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"style_imgStyle__M_t7Y"};